import createApiClient from './apiClient';

const studentApi = createApiClient(process.env.REACT_APP_ATHENIAN_STUDENT_SERVICE_URL);

export const getComplianceSnapshot = (params) =>
  studentApi.get('/compliance-snapshot', { params });
